module.exports = __webpack_public_path__ + "static/img/introduce_6.c5c0d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_6.png
// module id = +WdX
// module chunks = 1